import { useLanguage } from '../context/LanguageContext';
import { getTranslation, getTranslationOr } from '../translations';

/**
 * Hook for easy translation access
 * Usage: const { t, tOr } = useTranslation(); then t('key') or tOr('key', 'Fallback text')
 */
export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key, replacements = {}) => {
    return getTranslation(key, language, replacements);
  };

  const tOr = (key, fallback, replacements = {}) => {
    return getTranslationOr(key, language, fallback, replacements);
  };
  
  return { t, tOr, language };
};

